import { call, put, select, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { getNetworkOrdersRequest } from '../list/actions';
import { getNetworkOrdersSummaryRequest } from '../summary/actions';

function* getNetworkOrderDetail({ payload: { id, signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkOrders.detail, id, signal });
    yield put(actions.getNetworkOrderDetailDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getNetworkOrderDetailFailed,
      endpoint: api.networkOrders.detail.url
    });
  }
}

function* cancelNetworkOrder({ payload: { id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkOrders.cancel, id });
    yield put(actions.cancelNetworkOrderDone(data.result));
    // The Orders tab table/summary cards behind the drawer show this order's old status until
    // refetched - reads the table's own current filters rather than resetting them.
    const { curr_page, status, search, dateAfter, dateBefore } = yield select(s => s.getNetworkOrders);
    yield put(getNetworkOrdersRequest({ curr_page, status, search, dateAfter, dateBefore }));
    yield put(getNetworkOrdersSummaryRequest({}));
    onSuccess && onSuccess();
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.cancelNetworkOrderFailed,
      endpoint: api.networkOrders.cancel.url
    });
  }
}

export const getNetworkOrderDetailSaga = takeEvery(types.GET_NETWORK_ORDER_DETAIL_REQUEST, getNetworkOrderDetail);
export const cancelNetworkOrderSaga = takeEvery(types.CANCEL_NETWORK_ORDER_REQUEST, cancelNetworkOrder);
